import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Customer, EmailAddress } from "../../../../core/api/models";
import { toastr } from "react-redux-toastr";
import api from "../../../../api";
import {
  Company,
  UpdateCompanyData,
} from "../../../../core/api/models/company";
import { UploadUserImage } from "../../../../components/upload";

const EditCompanyLogo: React.FunctionComponent<{
  error?: string;
  onClose: () => void;
  updateCompany: (details: Company) => void;
  details?: Company;
  property: string;
  value?: string;
  title: string;
}> = (props) => {
  const { control, handleSubmit } = useForm<Customer>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const onSubmit = (updateData?: any) => {
    onUpdate(updateData.logo);
  };

  const onUpdate = async (logo: string) => {
    const updateData: UpdateCompanyData = {
      logo,
      name: props.details?.name,
      cinNumber: props.details?.cinNumber,
      fan: props.details?.fan,
      sector: props.details?.sector?._id,
      industry: props.details?.industry?._id,
      companySegment: props.details?.companySegment?._id,
      // salesType: props.details?.salesType?._id,
      addresses: props.details?.addresses,
    };

    try {
      const response = await api.company.updateCompnay(
        updateData,
        props.details?._id
      );

      props.updateCompany(response);
      props.onClose();
      toastr.success("Success", `Company ${props.title} updated successfully`);
    } catch (error) {
      if (error?.response?.data?.message) {
        toastr.error("Error", error?.response?.data?.message);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="d-flex flex-wrap px-4 py-1 contact-form-row active border-top border-bottom">
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center flex-wrap">
          <Controller
            control={control}
            name="logo"
            render={({ onChange, value, name }) => (
              <UploadUserImage id={"logo"} title={"Edit"} onChange={onChange} />
            )}
          />
        </div>
        <div className="col-12 pl-2 pr-0 mt-1 text-right">
          <button
            className="btn btn-sm btn-outline-dark mr-1 font-normal"
            onClick={props.onClose}
          >
            Cancel
          </button>
          <button className="btn btn-sm btn-primary font-normal">Save</button>
        </div>
      </div>
    </form>
  );
};

export default EditCompanyLogo;
